import { render, staticRenderFns } from "./color-edit.vue?vue&type=template&id=6d86cfb4"
import script from "./color-edit.vue?vue&type=script&lang=ts"
export * from "./color-edit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports